import $ from 'jquery';
import moment from 'moment';
import angular from 'angular';
import template from './dashboardView.html';
import Logger from '../../../../shared/logger';

export class DashboardComponent {
    /* @ngInject */
    constructor(
        $filter, StatsService, ActiveUsersService, ActiveJobsService,
        AnnualPerformanceService, RecruiterService, ConverstionKpiService,
        AnnualHiringFunnel, TESourcingProductivityService, RevenueDataService,
    ) {
        /* TODO Remove StatsService Once Moving To Services Is Done */
        const dashboardCtrl = this;

        dashboardCtrl.init = function () {
            StatsService.getBusinessKpi()
                .then((response) => {
                    dashboardCtrl.targets = response.result;
                    dashboardCtrl.revenuesData = RevenueDataService.getRevenuesFromResponseData(response);
                    dashboardCtrl.placementsWidget();
                    dashboardCtrl.annualPerf = {
                        view: 'NEW_JOBS',
                        dropdown: false
                    };
                    dashboardCtrl.getAnnualPerformanceData('Active Jobs', dashboardCtrl.targets);
                    dashboardCtrl.conversiondate = 'DASHBOARD_GRAPHS_LAST_30_DAYS';
                    dashboardCtrl.conversionKPIs(dashboardCtrl.conversiondate);
                    dashboardCtrl.sourcingProductivityDate = 'DASHBOARD_GRAPHS_DASHBOARD_LAST_WEEK';

                    const recruitersLength = dashboardCtrl.talenyaCtrl.recruiters.length + 1;

                    dashboardCtrl.talentExpertSourcingProductivity(dashboardCtrl.sourcingProductivityDate, null, recruitersLength);
                })
                .catch(error => Logger.error(error));
            dashboardCtrl.activeJobs();
            dashboardCtrl.activeUsers();
            dashboardCtrl.loadActivitySnapShotData('DASHBOARD_GRAPHS_DASHBOARD_CURRENT_MONTH');
            dashboardCtrl.hiringFunnelDate = 'DASHBOARD_GRAPHS_DASHBOARD_LAST_WEEK';
            dashboardCtrl.talentExpertHiringFunnel(dashboardCtrl.hiringFunnelDate);
        };

        dashboardCtrl.activitySnapShotSpanData =
            [
                'DASHBOARD_GRAPHS_DASHBOARD_CURRENT_MONTH',
                'DASHBOARD_GRAPHS_DASHBOARD_CURRENT_YEAR',
                'DASHBOARD_GRAPHS_DASHBOARD_LAST_90_DAYS',
            ];

        dashboardCtrl.timeFunnelDropDownData =
            [
                'DASHBOARD_GRAPHS_DASHBOARD_TODAY',
                'DASHBOARD_GRAPHS_DASHBOARD_YESTERDAY',
                'DASHBOARD_GRAPHS_DASHBOARD_LAST_WEEK',
                'DASHBOARD_GRAPHS_DASHBOARD_TWO_WEEKS_AGO',
                'DASHBOARD_GRAPHS_DASHBOARD_30_DAYS_AGO',
                'DASHBOARD_GRAPHS_DASHBOARD_60_DAYS_AGO',
                'DASHBOARD_GRAPHS_DASHBOARD_90_DAYS_AGO',
            ];

        dashboardCtrl.conversionDateDropDownData =
            [
                'DASHBOARD_GRAPHS_LAST_30_DAYS',
                'DASHBOARD_GRAPHS_LAST_365_DAYS',
                'DASHBOARD_GRAPHS_CURRENT_MONTH',
                'DASHBOARD_GRAPHS_CURRENT_YEAR',
            ];

        dashboardCtrl.annualPerfViews = [
            'NEW_JOBS',
            'ACTIVE_JOBS',
            'JOBS_IN_PROCESS',
            'JOBS_IN_ADVANCED_PROCESS',
            'AVERAGE_TIME_TO_HIRE',
            'NUMBER_OF_HIRES',
            'NEW_EMPLOYERS',
            'ACTIVE_EMPLOYERS',
            'PROFILE_SENT',
        ];

        const getDateBySnapShotActivityFormated = function (date) {
            return moment(date)
                .format('YYYY-MM-DD');
        };

        dashboardCtrl.talentExpertSourcingProductivity = function (data, recruiterId, numberOfRecruiters) {
            dashboardCtrl.showsourcingProductivityDropDown = false;
            dashboardCtrl.showSourcingProductivityRecruiter = false;
            const dateToday = new Date();
            const toDate = new Date();
            dashboardCtrl.sourcingProductivityDate = data;
            let numberToDivide = 0;
            switch (data) {
                case 'DASHBOARD_GRAPHS_DASHBOARD_TODAY':
                    dateToday.setDate(dateToday.getDate());
                    numberToDivide = 1;
                    break;
                case 'DASHBOARD_GRAPHS_DASHBOARD_YESTERDAY':
                    dateToday.setDate(dateToday.getDate() - 1);
                    toDate.setDate(toDate.getDate() - 1);
                    numberToDivide = 1;
                    break;
                case 'DASHBOARD_GRAPHS_DASHBOARD_LAST_WEEK':
                    dateToday.setDate(dateToday.getDate() - 8);
                    numberToDivide = 7;
                    break;
                case 'DASHBOARD_GRAPHS_DASHBOARD_TWO_WEEKS_AGO':
                    dateToday.setDate(dateToday.getDate() - 16);
                    numberToDivide = 14;
                    break;
                case 'DASHBOARD_GRAPHS_DASHBOARD_30_DAYS_AGO':
                    dateToday.setDate(dateToday.getDate() - 30);
                    numberToDivide = 30;
                    break;
                case 'DASHBOARD_GRAPHS_DASHBOARD_60_DAYS_AGO':
                    dateToday.setDate(dateToday.getDate() - 60);
                    numberToDivide = 60;
                    break;
                case 'DASHBOARD_GRAPHS_DASHBOARD_90_DAYS_AGO':
                    dateToday.setDate(dateToday.getDate() - 90);
                    numberToDivide = 90;
                    break;
            }
            if (data === 'DASHBOARD_GRAPHS_DASHBOARD_YESTERDAY') {
                TESourcingProductivityService.getTESourcingProductivityData(
                    getDateBySnapShotActivityFormated(dateToday),
                    getDateBySnapShotActivityFormated(toDate), recruiterId,
                    dashboardCtrl.targets, numberToDivide, numberOfRecruiters, (result) => {
                        $('#sourcing-productivity-chart')
                            .dxChart(result.options);
                    },
                );
            } else {
                TESourcingProductivityService.getTESourcingProductivityData(
                    getDateBySnapShotActivityFormated(dateToday), null, recruiterId, dashboardCtrl.targets,
                    numberToDivide, numberOfRecruiters, (result) => {
                        $('#sourcing-productivity-chart')
                            .dxChart(result.options);
                    },
                );
            }
        };

        dashboardCtrl.talentExpertHiringFunnel = function (data, recruiterId) {
            dashboardCtrl.showHiringFunnelDropDown = false;
            dashboardCtrl.showHiringFunnelRecruiter = false;
            const dateToday = new Date();
            switch (data) {
                case 'DASHBOARD_GRAPHS_DASHBOARD_LAST_WEEK':
                    dateToday.setDate(dateToday.getDate() - 8);
                    break;
                case 'DASHBOARD_GRAPHS_DASHBOARD_TWO_WEEKS_AGO':
                    dateToday.setDate(dateToday.getDate() - 16);
                    break;
                case 'DASHBOARD_GRAPHS_DASHBOARD_30_DAYS_AGO':
                    dateToday.setDate(dateToday.getDate() - 30);
                    break;
                case 'DASHBOARD_GRAPHS_DASHBOARD_60_DAYS_AGO':
                    dateToday.setDate(dateToday.getDate() - 60);
                    break;
                case 'DASHBOARD_GRAPHS_DASHBOARD_90_DAYS_AGO':
                    dateToday.setDate(dateToday.getDate() - 90);
                    break;
            }

            AnnualHiringFunnel.getAnunualHiringFunnel(getDateBySnapShotActivityFormated(dateToday), recruiterId, (data) => {
                $('#hiring-funnel-chart')
                    .dxChart(data.options);
            });
        };

        dashboardCtrl.activitySnapShotCollection = {};

        dashboardCtrl.loadActivitySnapShotData = function (data) {
            let dateToday = new Date();
            if (dashboardCtrl.activitySnapShotFromDate == data) {
                return;
            }
            dashboardCtrl.activitySnapShotFromDate = data;

            switch (data) {
                case 'DASHBOARD_GRAPHS_DASHBOARD_CURRENT_MONTH':
                    dateToday = new Date(dateToday.getFullYear(), dateToday.getMonth(), 1);
                    break;
                case 'DASHBOARD_GRAPHS_DASHBOARD_CURRENT_YEAR':
                    dateToday = new Date(dateToday.getFullYear(), 0, 1);
                    break;
                case 'DASHBOARD_GRAPHS_DASHBOARD_LAST_90_DAYS':
                    dateToday.setDate(dateToday.getDate() - 90);
                    break;
            }


            StatsService.getByTimeFrameEmployerActivitySnapshot({ from: getDateBySnapShotActivityFormated(dateToday) })
                .then((response) => {
                    dashboardCtrl.activitySnapShotCollection.employer = response.result;
                })
                .catch(error => Logger.error(error));
            StatsService.getByTimeFrameRecruiterActivitySnapshot({ from: getDateBySnapShotActivityFormated(dateToday) })
                .then((response) => {
                    dashboardCtrl.activitySnapShotCollection.recruiter = response.result;
                })
                .catch(error => Logger.error(error));
        };

        RecruiterService.getRecruiters()
            .then((response) => {
                dashboardCtrl.recruiters = response.result;
            })
            .catch(error => Logger.error(error));

        dashboardCtrl.activeJobs = function () {
            ActiveJobsService.getActiveJobsData((data) => {
                dashboardCtrl.activeJobsCount = data.activeJobsCount;
                $('#pie-active-jobs')
                    .dxPieChart(data.options);
            });
        };

        dashboardCtrl.conversionKPIs = function (date, recruiterId) {
            dashboardCtrl.showConversionDate = false;
            dashboardCtrl.showConversionRecruiters = false;
            let startDate = new Date();
            let previousFirstDate = new Date();
            let previousLastDate = new Date();
            if (date === 'DASHBOARD_GRAPHS_CURRENT_MONTH') {
                startDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
                previousFirstDate = new Date(startDate.getFullYear(), startDate.getMonth() - 1, 1);
                previousLastDate = new Date(startDate.getFullYear(), startDate.getMonth(), 0);
            } else if (date === 'DASHBOARD_GRAPHS_CURRENT_YEAR') {
                startDate = new Date(startDate.getFullYear(), 0, 1);
                previousFirstDate = new Date(startDate.getFullYear() - 1, 0, 1);
                previousLastDate = new Date(startDate.getFullYear(), 0, 0);
            } else if (date === 'DASHBOARD_GRAPHS_LAST_30_DAYS') {
                startDate = new Date(startDate.getFullYear(), startDate.getMonth(), -30);
                previousFirstDate = new Date(startDate.getFullYear(), startDate.getMonth(), -31);
                previousLastDate = new Date(startDate.getFullYear(), startDate.getMonth(), -1);
            } else { // 'DASHBOARD_GRAPHS_LAST_365_DAYS'
                startDate = new Date(startDate.getFullYear(), startDate.getMonth(), -365);
                previousFirstDate = new Date(startDate.getFullYear(), startDate.getMonth(), -366);
                previousLastDate = new Date(startDate.getFullYear(), startDate.getMonth(), -1);
            }
            ConverstionKpiService.getConverstionKpiService(
                getDateBySnapShotActivityFormated(startDate),
                {
                    from: getDateBySnapShotActivityFormated(previousFirstDate),
                    to: getDateBySnapShotActivityFormated(previousLastDate),
                }, recruiterId, dashboardCtrl.targets, (interviewedOptions, hiredOptions, rejectedOptions, conversionData) => {
                    $('#pie-conversion-kpis-interviewed')
                        .dxPieChart(interviewedOptions);
                    $('#pie-conversion-kpis-hired')
                        .dxPieChart(hiredOptions);
                    $('#pie-conversion-kpis-rejected')
                        .dxPieChart(rejectedOptions);
                    dashboardCtrl.interviewedData = interviewedOptions.dataSource;
                    dashboardCtrl.hiredData = hiredOptions.dataSource;
                    dashboardCtrl.rejectedData = rejectedOptions.dataSource;
                    dashboardCtrl.conversionData = conversionData;
                },
            );
        };

        dashboardCtrl.getAnnualPerformanceData = function (type, targets) {
            const fromDate = dashboardCtrl.getDateFormatYYYYMMDD();
            AnnualPerformanceService.getAnnualPerformanceData(fromDate, type, targets, (data) => {
                const options = AnnualPerformanceService.getAnnualPerformanceOptions(data.dataSource);
                $('#bar-chart-annual-performance')
                    .dxChart(options)
                    .dxChart('instance');
            });
        };

        dashboardCtrl.placementsWidget = function () {
            const fromDate = dashboardCtrl.getDateFormatYYYYMMDD('last year');
            AnnualPerformanceService.getAnnualPerformanceData(fromDate, 'Number Of Hires', dashboardCtrl.targets, (data) => {
                const options = AnnualPerformanceService.getActivitySnapshotOptions(data.dataSource, dashboardCtrl.targets);
                $('#bar-chart-activity-snapshot-monthly')
                    .dxChart(options[0])
                    .dxChart('instance');
                $('#bar-chart-activity-snapshot-yearly')
                    .dxChart(options[1])
                    .dxChart('instance');
            });
        };

        dashboardCtrl.activeUsers = function () {
            ActiveUsersService.getActiveUsersData((data) => {
                dashboardCtrl.onlineUsersData = data.online;
                dashboardCtrl.activeUsersData = data.active;
            });
        };

        dashboardCtrl.annualPrefChanged = function () {
            if (dashboardCtrl.annualPerf.view == 'NEW_JOBS') {
                dashboardCtrl.getAnnualPerformanceData('New Jobs', dashboardCtrl.targets);
            } else if (dashboardCtrl.annualPerf.view == 'ACTIVE_JOBS') {
                dashboardCtrl.getAnnualPerformanceData('Active Jobs', dashboardCtrl.targets);
            } else if (dashboardCtrl.annualPerf.view == 'JOBS_IN_PROCESS') {
                dashboardCtrl.getAnnualPerformanceData('Jobs in Process', dashboardCtrl.targets);
            } else if (dashboardCtrl.annualPerf.view == 'JOBS_IN_ADVANCED_PROCESS') {
                dashboardCtrl.getAnnualPerformanceData('Advanced jobs', dashboardCtrl.targets);
            } else if (dashboardCtrl.annualPerf.view == 'NUMBER_OF_HIRES') {
                dashboardCtrl.getAnnualPerformanceData('Number Of Hires', dashboardCtrl.targets);
            } else if (dashboardCtrl.annualPerf.view == 'ACTIVE_EMPLOYERS') {
                dashboardCtrl.getAnnualPerformanceData('Active Employers', dashboardCtrl.targets);
            } else if (dashboardCtrl.annualPerf.view == 'NEW_EMPLOYERS') {
                dashboardCtrl.getAnnualPerformanceData('New Employers', dashboardCtrl.targets);
            } else if (dashboardCtrl.annualPerf.view == 'AVERAGE_TIME_TO_HIRE') {
                dashboardCtrl.getAnnualPerformanceData('Average Time To Hire', dashboardCtrl.targets);
            } else if (dashboardCtrl.annualPerf.view == 'PROFILE_SENT') {
                dashboardCtrl.getAnnualPerformanceData('Profile Sent', dashboardCtrl.targets);
            }
        };

        dashboardCtrl.activitySnapshot = function () {
            const fromDate = dashboardCtrl.getDateFormatYYYYMMDD('last year');
            AnnualPerformanceService.getAnnualPerformanceData(fromDate, 'Number Of Hires', (data) => {
                const options = AnnualPerformanceService.getActivitySnapshotOptions(data.dataSource);
                $('#bar-chart-activity-snapshot-monthly')
                    .dxChart(options[0])
                    .dxChart('instance');
                $('#bar-chart-activity-snapshot-yearly')
                    .dxChart(options[1])
                    .dxChart('instance');
            });
        };

        dashboardCtrl.getDateFormatYYYYMMDD = function (type) {
            const currentDate = new Date(Date.now());
            let month = currentDate.getMonth() + 1;
            let day = currentDate.getDate();
            const year = currentDate.getFullYear();

            if (type) {
                day = 1;
                month = 1;
            }
            if (month < 10 && month > 0) {
                month = `0${month}`;
            }
            if (day < 10 && day > 0) {
                day = `0${day}`;
            }
            let retVal = '';
            retVal = [year - 1, month, day].join('-');
            return retVal;
        };
    }
}

export const DashboardComponentConfiguration = {
    require: {
        talenyaCtrl: '^talenyaComponent',
    },
    template,
    controller: DashboardComponent,
    controllerAs: 'dashboardCtrl',
};

angular
    .module('TALENYA-FE')
    .component('dashboardComponent', DashboardComponentConfiguration);

